
import api from "../../../utilidades/interceptor";
const apiKey = process.env.REACT_APP_API_KEY;


export const getFatigueMonitor = async () => {
    try {
        const response = await api.get(`${apiKey}/seguridad/fatigaOperativa`);
        return response.data;
    } catch (error) {
        console.log("error getFatigueMonitor", error);
        return null;
    }
}